// extracted by mini-css-extract-plugin
var _1 = "ConfirmTransfer-AO9dZ";
var _2 = "Paragraph-AF2nX";
var _3 = "Pink-CEA7e";
var _4 = "Title-aXhsa";
export { _1 as "ConfirmTransfer", _2 as "Paragraph", _3 as "Pink", _4 as "Title" }
